import AdminApi from '../services/api';
import swal from 'sweetalert2';
import CONFIG_COMPANY from "../services/myConfig";
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {

    props: ['show', 'skipTrainerSelect'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            users: [],
            successAdd: '',
            hasError: '',
            filter: '',
            partners: [],
            selectedPartners: [],
            mustSelectTrainerWhenReserveTraining: null,
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            }
        };
    },

    watch: {
        show: function (val, oldVal) {
            if(val === true){
                this.mustSelectTrainerWhenReserveTraining = this.skipTrainerSelect === true ? false : CONFIG_COMPANY.MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN;
                this.getPartners();
            }
        },
    },

    beforeMount() {

    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeChooseUser')
        },
        chooseUser: chooseUser,
        isActiveMemberShip: isActiveMemberShip,
        formatDate: formatDate,
        getStyleActiveMembership: getStyleActiveMembership,
        keymonitor: keymonitor,
        goToPayments: goToPayments,
        reset: reset,
        load: load,
        getPartners: getPartners,
        clickSelectPartner: clickSelectPartner,
        isSelected: isSelected,
        getChipClass: getChipClass,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile() {
            if (this.isMobile()) {
                return 'modal--small modal--choose-user'
            } else {
                return 'modal--large modal--choose-user'
            }
        },
        modalStyle() {
            if (this.isMobile()) {
                return 'color: white; background-color: black;'
            } else {
                return ''
            }
        },
        mainDivStyle() {
            if (this.isMobile()) {
                return 'background-color: #1C242D; color: #ffffff;'
            } else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle() {
            if (this.isMobile()) {
                return 'height: auto !important; overflow: visible; padding: 8px 12px 12px;';
            }
            return 'height: auto !important; overflow: visible; padding: 8px 12px 12px;';
        }
    }
}

function getPartners(){
    if(this.mustSelectTrainerWhenReserveTraining !== true) return
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.partners = response.data.map(e=> e.name);
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {
    let _self = this;
    _self.isLoading = true;

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        debtor: false
    }

    AdminApiService.getUsers(request)
        .then((response) => {
            _self.users = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
            _self.isLoading = false;
        })
        .catch((error) => {
            _self.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset() {
    this.isLoading = false;
    this.users = []
    this.filter = ''
    this.hasError = ''
    this.successAdd = ''
    this.pagination = {
        page: 1,
        limit: 100,
        totalCount: 0
    }
}

function chooseUser(user) {
    if(this.mustSelectTrainerWhenReserveTraining === true && this.selectedPartners.length === 0){
        this.hasError = LocService.t('label_please_select_trainer');
        return;
    }
    this.reset();
    if(this.mustSelectTrainerWhenReserveTraining === true){
        user.selectedTrainer = this.selectedPartners[0]
    }
    this.$topnavbar.$emit('onUserSelected', user)
    this.successAdd = LocService.t('label_success_added_user') + ': ' + user.name + " " + user.surname;
    // swal(LocService.t('label_success_added_user'), user.name +" "+ user.surname,'success')
}

function isActiveMemberShip(user) {
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const currentTimeInMilliseconds = currentDate.getTime();
    if (currentTimeInMilliseconds > (user.expireDate * 1000 + 10800000)) {
        return false;
    } else {
        return true;
    }
}

function getStyleActiveMembership(user) {
    if (!this.isActiveMemberShip(user)) {
        return 'color: red;'
    }
    return '';
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function goToPayments(user) {
    const url = this.$router.resolve({
        path: '/user-profile',
        query: {id: user.id, name: user.name + ' ' + user.surname, type: 'payments'}
    }).href;
    window.open(url, '_blank');
}

function getChipClass(item){
    if(this.selectedPartners.includes(item)){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item){
    return this.selectedPartners.includes(item)
}

function clickSelectPartner(item){
    if(this.selectedPartners.includes(item)){
        this.selectedPartners = [];
        this.hasError = LocService.t('label_please_select_trainer');
    }else{
        this.hasError ='';
        this.selectedPartners = [];
        this.selectedPartners.push(item)
    }
}



// WEBPACK FOOTER //
// ./src/modals/ChooseUserModal.js